package com.appcreator.compose

class SuppressedException(override val cause: Exception): Exception(cause)